module.exports = __webpack_public_path__ + "static/media/chorthippus_albomarginatus_004_APA.9dc4ca3c.png";